import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
import ArrowIosUp from '@crehana/compass.icons.outline/ArrowIosUp';
import { LazyImage } from '@crehana/compass.ui';
import { clsx } from 'clsx';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ProfileButton = function ProfileButton(_ref) {
  var toggleOpen = _ref.toggleOpen,
    user = _ref.user,
    userRoleLabel = _ref.userRoleLabel,
    isOpen = _ref.isOpen;
  var thumbnailUrl = user.thumbnailUrl,
    fullName = user.fullName;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovered = _useState2[0],
    setIsHovered = _useState2[1];
  var shouldRenderAccentedColor = isOpen || isHovered;
  var regularColor = 'dark:tw-text-neutral-dark-300 tw-text-neutral-light-800';
  var accentedColor = 'dark:tw-text-secondary-light-500 tw-text-primary-light-500';
  var textColor = shouldRenderAccentedColor ? accentedColor : regularColor;
  return /*#__PURE__*/_jsxs("button", {
    id: "user-avatar",
    className: "outline-none tw-flex tw-items-center",
    onMouseOver: function onMouseOver() {
      return setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovered(false);
    },
    onClick: toggleOpen,
    onFocus: function onFocus() {
      // Empty function to fix eslint warning
    },
    type: "button",
    children: [/*#__PURE__*/_jsx(LazyImage, {
      className: "tw-w-3.6 tw-h-3.6 md:tw-h-3.2 md:tw-w-3.2 tw-rounded-full tw-flex-shrink-0 tw-overflow-hidden",
      imgClassName: "tw-object-cover tw-object-center",
      src: thumbnailUrl,
      alt: fullName
    }), /*#__PURE__*/_jsxs("div", {
      className: "tw-hidden md:tw-block tw-overflow-hidden tw-ml-1.2 tw-mr-1.2 tw-w-max-[18rem]",
      children: [/*#__PURE__*/_jsx("p", {
        className: clsx('tw-text-left tw-font-subtitle5 tw-truncate', textColor),
        children: fullName
      }), userRoleLabel && /*#__PURE__*/_jsx("p", {
        className: "tw-text-left tw-font-body5 dark:tw-text-neutral-dark-500 tw-text-neutral-light-700",
        children: userRoleLabel
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: clsx('tw-transition-transform tw-will-change-transform tw-duration-300',
      // Breakpoints
      'tw-hidden md:tw-block', isOpen ? 'tw-rotate-0' : 'tw-rotate-180'),
      children: /*#__PURE__*/_jsx(ArrowIosUp, {
        size: 20,
        className: textColor
      })
    })]
  });
};
export default ProfileButton;